var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DispatcherImpl, decodeMessage } from '../message/index.js';
import { KeepAlive } from './keep-alive.js';
var Connection = /** @class */ (function (_super) {
    __extends(Connection, _super);
    function Connection(options) {
        var _this = _super.call(this) || this;
        var socketConstructor = options.socketConstructor, lifeCount = options.lifeCount;
        _this._status = 'initialized';
        _this.socketConstructor = socketConstructor;
        _this.lifeCount = lifeCount !== null && lifeCount !== void 0 ? lifeCount : 10;
        _this.currentLifeCount = _this.lifeCount;
        _this.closed = false;
        _this.pendingMessages = [];
        return _this;
    }
    Connection.prototype.open = function () {
        var _this = this;
        this.closed = false;
        this.status = 'connecting';
        this.socket = this.socketConstructor();
        this.keepAlive = new KeepAlive(this.socket, 30000);
        this.socket.onclose = function () {
            _this.keepAlive.stop();
            _this.status = 'disconnected';
            _this.currentLifeCount -= 1;
            _this.socket = undefined;
            if (!_this.closed && _this.currentLifeCount > 0) {
                _this.open();
            }
            if (_this.currentLifeCount === 0) {
                _this.close();
                _this.status = 'unavailable';
            }
        };
        this.socket.onopen = function () {
            var _a;
            _this.keepAlive.start();
            if (_this.closed) {
                (_a = _this.socket) === null || _a === void 0 ? void 0 : _a.close();
                return;
            }
            _this.status = 'connected';
            _this.currentLifeCount = _this.lifeCount;
            for (var _i = 0, _b = _this.pendingMessages; _i < _b.length; _i++) {
                var message = _b[_i];
                try {
                    _this.socket.send(message);
                }
                catch (_c) {
                    console.error('Failed to send pending message');
                }
            }
            _this.pendingMessages = [];
        };
        this.socket.onerror = function () {
            _this.currentLifeCount -= 1;
        };
        this.socket.onmessage = function (messageEvent) {
            var incomingMessage = decodeMessage(messageEvent.data);
            if (incomingMessage.action !== 'ping') {
                _this.keepAlive.stop();
                _this.keepAlive.start();
            }
            _this.emit('message', incomingMessage);
        };
    };
    Connection.prototype.close = function () {
        this.closed = true;
        if (this.socket && this.status === 'connected') {
            this.socket.close();
        }
        this.socket = undefined;
    };
    Connection.prototype.send = function (message) {
        if (this.socket && this.status === 'connected') {
            this.socket.send(message);
        }
        else {
            this.pendingMessages.push(message);
        }
    };
    Object.defineProperty(Connection.prototype, "status", {
        get: function () {
            return this._status;
        },
        set: function (status) {
            this._status = status;
            this.emit('status', status);
        },
        enumerable: false,
        configurable: true
    });
    return Connection;
}(DispatcherImpl));
export { Connection };
